import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDateTime } from "@/components/badges";
import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fmtSize } from "./utils";

export function VersionsDialog({ doc, onClose, onDownload }) {
  const { t } = useTranslation();
  const { data: versions = [], isFetching: loadingVersions } = useQuery({
    queryKey: ["drive-versions", doc?.id],
    queryFn: async () => (await api.get(`/drive/files/${doc.id}/versions`)).data,
    enabled: !!doc,
  });

  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="drive-versions-dialog">
        <DialogHeader><DialogTitle>{t("driveExplorer.versionsTitle")} — {doc?.filename}</DialogTitle></DialogHeader>
        <div className="max-h-80 space-y-1 overflow-y-auto" data-testid="drive-versions-list">
          {loadingVersions && <p className="py-4 text-center text-xs text-slate-500">{t("common.loading")}</p>}
          {!loadingVersions && versions.length === 0 && <p className="py-4 text-center text-xs text-slate-500">{t("driveExplorer.noVersions")}</p>}
          {!loadingVersions && versions.map((v) => (
            <div key={v.id} className={`flex items-center justify-between gap-2 rounded-md border px-2.5 py-1.5 text-xs ${v.is_latest ? "border-sky-300 bg-sky-50" : ""}`} data-testid={`drive-version-row-${v.id}`}>
              <div className="min-w-0">
                <span className="font-mono font-semibold">{v.version}</span>
                {v.is_latest && <Badge variant="outline" className="ml-2 bg-sky-100 font-mono text-[10px] text-sky-800">{t("badges.current")}</Badge>}
                <span className="ml-2 text-slate-500">{fmtSize(v.size)} · {v.uploaded_by_email} · {fmtDateTime(v.uploaded_at)}</span>
              </div>
              <Button variant="ghost" size="icon" title={t("driveExplorer.downloadVersionT")} onClick={() => onDownload(v)} data-testid={`drive-version-download-${v.id}`}>
                <Download className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
